export default __webpack_public_path__ + "static/leadership-combo-141b1955f8c00feb89774c1371dfe79b.png";